import PropTypes from 'prop-types';

export const RoomsPaxProps = PropTypes.shape({
    adults: PropTypes.number.isRequired,
    kids: PropTypes.arrayOf(PropTypes.number).isRequired,
});
